import { render, staticRenderFns } from "./HomeObjectives.vue?vue&type=template&id=5d8d1957&"
import script from "./HomeObjectives.vue?vue&type=script&lang=js&"
export * from "./HomeObjectives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports